import { useEffect } from 'react'
import type { Variants } from '@mc/experiments'
import { useBucket, useExperimentVariables } from '@mc/experiments-react'
import { PROMO_FEATURE_FLAG } from './constants'
import { trackPromotionExperimentViewed } from './trackPromotionExperimentViewed'

export const usePromotion = ({ isGift = false }: { isGift?: boolean } = {}) => {
  const promoBucket = useBucket(PROMO_FEATURE_FLAG)
  const variables = useExperimentVariables(PROMO_FEATURE_FLAG)

  const { isPromotionOn } = shouldShowPromotion({
    promoBucket,
    isGift,
    isPromoGiftEligible: !!variables.gift_eligible,
  })

  const promoKey = variables.promo_key as string

  useEffect(() => {
    if (isPromotionOn) {
      trackPromotionExperimentViewed(promoKey, promoBucket)
    }
  }, [promoBucket, promoKey, isPromotionOn])

  return {
    isPromotionOn,
    variables,
  }
}

// conditions to show/hide promotion
export const shouldShowPromotion = ({
  promoBucket,
  isGift = false,
  isPromoGiftEligible = false,
}: {
  promoBucket?: Variants | null
  isGift?: boolean
  isPromoGiftEligible?: boolean
}) => {
  const isPromotionOn = !!promoBucket && (!isGift || isPromoGiftEligible)

  return {
    isPromotionOn,
  }
}
